import { render, staticRenderFns } from "./ProductLabelEditForm.vue?vue&type=template&id=3c671d0e&scoped=true&"
import script from "./ProductLabelEditForm.vue?vue&type=script&lang=js&"
export * from "./ProductLabelEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelEditForm.vue?vue&type=style&index=0&id=3c671d0e&lang=scss&scoped=true&"
import style1 from "./ProductLabelEditForm.vue?vue&type=style&index=1&id=3c671d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c671d0e",
  null
  
)

export default component.exports